import { Injectable } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable, of } from "rxjs";
import { AmsNotifierService } from "../../shared/services/ams-notifier.service";
import { UserService } from "../../shared/services/user.service";

@Injectable({
  providedIn: "root"
})
export class ApiBaseService {
  protected baseUrl: string;
  private notifier: AmsNotifierService;

  loading$ = new BehaviorSubject<boolean>(false);

  private _httpOptions = null;
  protected get httpOptions() {
    //BEA 2022-04-01 force the SessionId to be read from the localstorage each time the httpOptions is used (to avoid using and old session)
    const headders = this._httpOptions.headers.set("SessionId", this.userService.sessionId);
    return { headers: headders };
  }
  protected set httpOptions(val) {
    this._httpOptions = val;
  }

  constructor(protected userService: UserService) {
    this._httpOptions = { headers: new HttpHeaders({ "content-type": "application/json" }) };
    this.notifier = new AmsNotifierService();
  }

  protected handleError<T>(operation = "operation", result: T = null, display = true) {
    return (err: any): Observable<T> => {
      const isAnError = err !== "Error Code: 200" && err !== "Error Code: 201";

      if (isAnError) {
        this.showErrorIfActivated(display, err, operation);
      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  private showErrorIfActivated(display: boolean, err: any, operation: string) {
    if (!display) { return; }
    this.notifier.errorWithTimeout(this.getErrorMessage(err, operation));
  }

  private getErrorMessage(err: any, operation: string): string {
    const message = operation;
    return `${message}: ${err}`;
  }
}
